import { useMemo } from 'react';
import { SelectOption } from '@cbhq/cds-web/controls';
import { Dropdown } from '@cbhq/cds-web/dropdown';
import { Icon } from '@cbhq/cds-web/icons';
import { Box, HStack } from '@cbhq/cds-web/layout';
import { Tag } from '@cbhq/cds-web/tag/Tag';
import { TextHeadline } from '@cbhq/cds-web/typography';

import { BaseL3Chain } from ':cloud/types/ts_types';

import { DROPDOWN_CONTENT_POSITION } from '../navigation/constants';

import { BaseAppchainStatusEnum, BaseNetworkEnum } from './constants';

type NetworkSelectorProps = {
  mainnet?: BaseL3Chain;
  testnet?: BaseL3Chain;
  selectedChain?: BaseL3Chain;
  selectedNetwork?: string;
  setSelectedNetwork: (network: string) => void;
};

export function NetworkSelector({
  mainnet,
  testnet,
  selectedChain,
  setSelectedNetwork,
  selectedNetwork,
}: NetworkSelectorProps) {
  const dropdownContent = useMemo(() => {
    return (
      <>
        <SelectOption
          value={BaseNetworkEnum.Testnet}
          title={
            <HStack alignItems="center" gap={2}>
              <TextHeadline as="h1">{testnet?.name}</TextHeadline>
              <Tag colorScheme="green">Testnet</Tag>
            </HStack>
          }
        />
        <SelectOption
          value={BaseNetworkEnum.Mainnet}
          title={
            <HStack alignItems="center" gap={2}>
              <TextHeadline as="h1">{mainnet?.name}</TextHeadline>
              <Tag colorScheme="yellow">Mainnet</Tag>
            </HStack>
          }
        />
      </>
    );
  }, [mainnet?.name, testnet?.name]);

  if (
    mainnet?.status === BaseAppchainStatusEnum?.Running &&
    testnet?.status === BaseAppchainStatusEnum?.Running
  ) {
    return (
      <Box alignItems="center" spacingHorizontal={7} justifyContent="flex-end" flexGrow={1}>
        <Dropdown
          contentPosition={DROPDOWN_CONTENT_POSITION}
          onChange={setSelectedNetwork}
          content={dropdownContent}
        >
          <HStack alignItems="center" gap={2} flexGrow={1}>
            <TextHeadline as="h1">{selectedChain?.name}</TextHeadline>
            {selectedNetwork === BaseNetworkEnum.Testnet ? (
              <Tag colorScheme="green">Testnet</Tag>
            ) : (
              <Tag colorScheme="yellow">Mainnet</Tag>
            )}
            <Icon name="caretDown" size="m" color="foreground" />
          </HStack>
        </Dropdown>
      </Box>
    );
  }

  return (
    <Box alignItems="center" spacingHorizontal={7} justifyContent="flex-end" flexGrow={1}>
      <TextHeadline as="h1" spacingEnd={2}>
        {selectedChain?.name}
      </TextHeadline>
      {selectedChain?.network === BaseNetworkEnum?.Testnet ? (
        <Tag colorScheme="green">Testnet</Tag>
      ) : (
        <Tag colorScheme="yellow">Mainnet</Tag>
      )}
    </Box>
  );
}
